import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'

import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/pt-br'

import './index.css'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import { AppRouter } from '@routes'
import { store } from '@store'
// import { AppInitializer } from './AppInitializer'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('America/Sao_Paulo')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<Router>
				{/* <AppInitializer /> */}
				<AppRouter />
			</Router>
		</Provider>
	</React.StrictMode>
)
